import {coerceToString} from "../../../utils/coerceToString";

export function calculateEditedRows(rowKey, fieldName, value, currentValue, currentEditedRows) {
    /**
     *
     * Calculates the edited row data based on the current edited rows and the new value(s).
     *
     * The two important bits of information when calculating the new edited rows is:
     *   1) Is the value already stored in the edited rows state
     *   2) Is the value equal to the initial value
     *
     * Each option is yes/no which results in four possible states we need to account for, although the two yes + no
     * combinations result in noops.
     *
     * */

    // unpack our own local copy of the current state
    const newEditedRows = { ...currentEditedRows };

    let rowLevelData = newEditedRows[rowKey];
    if ( rowLevelData === undefined ) {
        rowLevelData = [];
    }

    const existingFieldEntry =  rowLevelData.filter(item => (item.fieldName === fieldName))[0];

    if ( existingFieldEntry !== undefined ) {
        // there is already an entry for this field. We only want to remove this entry if the value matches the initial.
        if ( coerceToString(value) === coerceToString(existingFieldEntry.initialValue) ) {
            rowLevelData = rowLevelData.filter(item => (item.fieldName !== fieldName));
        }
    } else {
        // there is not already an entry for this field. We only want to add one if the value is not the same as the
        // current value, which is actually equal to the initial value in this instance.
        if ( coerceToString(value) !== coerceToString(currentValue) ) {
            rowLevelData = [...rowLevelData, {fieldName: fieldName, initialValue: currentValue}]
        }
    }

    if ( rowLevelData.length > 0 ) {
        newEditedRows[rowKey] = rowLevelData;
    } else {
        delete newEditedRows[rowKey];
    }

    return newEditedRows
}
